"use strict";module.exports = {
  handleCloseButton: function handleCloseButton(originalEvent) {
    this.emit('overlay-close', { originalEvent: originalEvent });
  } };